import { SET_REVIEWED_FORM_IDS } from "../../redux/actions/action.types";

export default function setReviewedFormIds(stateSetter: any, successfulIdsArray: any) {
  stateSetter({
    type: SET_REVIEWED_FORM_IDS,
    payload: successfulIdsArray,
  });
}
